import React from 'react';
import { DayPicker } from 'react-day-picker';

import { cn } from '../../utils/cn';

import 'react-day-picker/style.css';

export const Calendar = ({ className, ...props }) => (
  <DayPicker
    className={cn('dt-rdp', className)}
    {...props}
  />
);
